import {
  PrimitiveCacheConstructor,
  PrimitiveCache,
} from './primitiveCacheTypes';

export const createPrimitiveCache = <ValueType>(
  value: ValueType
): PrimitiveCache<ValueType> => ({
  value,
  invalidated: false,
});

export const createPrimitiveCacheConstructor = <ValueType>(
  cache: PrimitiveCache<ValueType>
): PrimitiveCacheConstructor<ValueType> => ({
  get() {
    return cache;
  },
  setValue(value) {
    return createPrimitiveCacheConstructor({
      invalidated: false,
      value,
    });
  },
  invalidate() {
    return createPrimitiveCacheConstructor({
      ...cache,
      invalidated: true,
    });
  },
});
